import React from 'react';
import Inventory from '../../mechanics/inventory/Inventory';
import { Item } from '../../mechanics/items/Item';
import { userSlice } from '../../store/reducers/userReducer';
import { useAppDispatch, useAppSelector } from '../../store/store';
import './UseItemOptions.scss'

interface IUseItemOptionsProps {
    item: Item
    itemCount: number
    setItemCount: React.Dispatch<React.SetStateAction<number>>
    index: number
    setPlayerHp?: React.Dispatch<React.SetStateAction<number>> | undefined
    setViewItemOptions: React.Dispatch<React.SetStateAction<boolean>>
}


const UseItemOptions = ({ item, itemCount, setItemCount, index, setPlayerHp, setViewItemOptions }: IUseItemOptionsProps) => {
    const dispatch = useAppDispatch()
    const mainCharacter = useAppSelector(state => state.userReducer.character)
    const characterInventory = mainCharacter.getInventory()
    const { setInventoryLength, setIsEquipmentChange, setIsBuyOrSellItem } = userSlice.actions

    const isArmorEquipped = mainCharacter.getEquipment().armor.getArmorType()
    const isWeaponEquipped = mainCharacter.getEquipment().weapon.getWeaponType()
    const isEquipmentChange = useAppSelector(state => state.userReducer.isEquipmentChange)

    const defaultOperations = () => {
        item.useItem(mainCharacter, characterInventory)
        setItemCount(item.getCount())
        if (itemCount === 1)
            characterInventory.deleteFromInventory(index)

        dispatch(setInventoryLength())
    }

    const use = () => {
        defaultOperations()
        if (setPlayerHp) {
            setPlayerHp(mainCharacter.getHp())
        }
    }

    const wear = () => {
        defaultOperations()
        if (isArmorEquipped || isWeaponEquipped) {
            dispatch(setIsEquipmentChange(!isEquipmentChange))
        }
    }

    const sell = () => {
        item.sellItem(mainCharacter, characterInventory, index)
        setItemCount(item.getCount())
        dispatch(setIsBuyOrSellItem())
    }

    const options = () => {
        if (item.getType() === 'potion') {
            return (
                <ul className='options' onMouseLeave={() => setViewItemOptions(false)}>
                    <li className='options__item' onClick={use}>use</li>
                    <li className='options__item' onClick={sell}>sell</li>
                    <li className='options__item'>delete</li>
                </ul>
            )
        }

        return (
            <ul className='options' onMouseLeave={() => setViewItemOptions(false)}>
                <li className='options__item' onClick={wear}>wear</li>
                <li className='options__item' onClick={sell}>sell</li>
                <li className='options__item'>delete</li>
            </ul>
        )
    }


    return (
        <>
            {options()}
        </>
    );
};

export default UseItemOptions;
